import { WintSuperkollAPIModel } from "wint-api-client/dist/types";

function usePrintAllowed() {
  const getPrintAllowed = (
    invoiceId: number | undefined,
    canSendLastVersionToPagero: boolean,
    isRegisteredAtPagero: boolean,
    version: number | undefined,
    isReminder: boolean,
    status: WintSuperkollAPIModel.InvoiceStatus | undefined
  ) => {
    const canSendToPagero =
      invoiceId && canSendLastVersionToPagero !== undefined
        ? isReminder
          ? isRegisteredAtPagero
          : canSendLastVersionToPagero
        : isRegisteredAtPagero;

    const printAllowed =
      version === undefined && status !== WintSuperkollAPIModel.InvoiceStatus.Collection && canSendToPagero;

    return printAllowed;
  };
  return { getPrintAllowed };
}

export default usePrintAllowed;
